<template>
  <div v-if="user.id" style="position: relative" class="createPostBtnWrapper">
    <TabsMenuRight :profile="user" :key="user.id" />
    <v-tabs v-model="tab" align-with-title class="tabs-menu">
      <v-tabs-slider></v-tabs-slider>
      <v-tab v-for="(tab, idx) in tabsComponent" :key="idx">
        {{ tab.title }}
      </v-tab>
      <v-tabs-items v-model="tab" touchless>
        <v-tab-item
          transition="fade-transition"
          reverse-transition="fade-transition"
        >
          <v-row dense>
            <v-col cols="12" :md="8">
              <PostList action="post/getUserPost" :userPost="user.profile" :typeShowText="{name:`${user.lastName} ${user.firstName}`, type: 'user'}" />
            </v-col>
            <v-col cols="12" :md="4"> </v-col>
          </v-row>
        </v-tab-item>
        <v-tab-item
          transition="fade-transition"
          reverse-transition="fade-transition"
        >
          <GolfPlayed :user="user" />
        </v-tab-item>
        <v-tab-item
          transition="fade-transition"
          reverse-transition="fade-transition"
        >
          <Subscriptions :user="user" />
        </v-tab-item>
      </v-tabs-items>
    </v-tabs>
  </div>
</template>
<script>
// tabs
import PostList from "@/components/Post/PostList";
import GolfPlayed from "@/components/ProfilePerson/GolfPlayed";
import Subscriptions from "@/components/ProfilePerson/Subscriptions";
import TabsMenuRight from "@/components/ProfilePerson/TabsMenuRight";

export default {
  name: "ProfilePerson",
  props: {
    user: {
      type: Object,
      default: () => {}
    }
  },
  components: {
    PostList,
    GolfPlayed,
    Subscriptions,
    TabsMenuRight
  },
  data() {
    return {
      tab: null,
      postData: {}
      // info: null,
    };
  },
  mounted() {
  },
  computed: {
    tabsComponent() {
      return [
        {
          title: this.$gettext("Timeline")
        },
        {
          title: this.$gettext("Golf played")
        },
        {
          title: this.$gettext("Subscriptions")
        }
      ];
    }
  }
};
</script>
